import React from "react";
import { useActivePageRegistration } from "@hex-insights/router";
import { MessageGroupComponents, useMessageGroupDetailQuery } from "@hex-insights/verita-romania.shared";
import { messagingMessageGroupPageInfo } from "./pageinfo";
import styles from "./styles.module.css";

export function MessagingMessageGroupPage() {
	const { messageGroupID } = messagingMessageGroupPageInfo.useParams();

	const { data } = useMessageGroupDetailQuery({ variables: { id: messageGroupID } });
	const messageGroup = data?.messageGroup;
	useActivePageRegistration(
		messagingMessageGroupPageInfo,
		!!messageGroup ? messagingMessageGroupPageInfo.title(messageGroup) : "",
	);

	return (
		<React.Fragment>
			<div className={styles["top-coverer"]}></div>
			<MessageGroupComponents.DetailView messageGroupID={messageGroupID} messageGroup={messageGroup} />
		</React.Fragment>
	);
}
